import React from 'react';
import { Grid } from '@mui/material';
import { observer } from 'mobx-react';
import { useTranslation } from '@gamiphy/react-i18n';
import { useCountDown } from '@gamiphy/loyalty-station-desktop/components/promotion/hooks';
import { padWithZero } from '@gamiphy/utils/date';
import { PopupsStore } from '@gamiphy/loyalty-station-desktop/store/popups';

type Props = {
  endDate: string,
  fontSize: string,
  labelsFontSize: string,
}

const CountDown: React.FC<Props> = (observer(({
  endDate, fontSize, labelsFontSize,
}) => {
  const { t } = useTranslation();

  const {
    days,
    hours,
    minutes,
    seconds,
  } = useCountDown(new Date(endDate));

  React.useEffect(() => {
    if (hours === 0 && minutes === 0 && seconds === 0 && days === 0) {
      PopupsStore.closePopup();
    }
  }, [hours, minutes, seconds]);

  return (
    <Grid
      container
      gap={1}
      justifyContent="center"
      sx={{
        fontSize: '2rem',
        lineHeight: 1,
        textAlign: 'center',
        fontWeight: 'bold',
      }}
    >
      <Grid container direction="column" flex={1}>
        <Grid sx={{ fontSize, fontWeight: 'bold' }}>
          {padWithZero(days)}
        </Grid>
        <Grid sx={{
          fontSize: labelsFontSize,
          lineHeight: 1,
          fontWeight: 'normal',
        }}
        >
          {t('pointsExpiry.units.days', { defaultValue: 'Days' })}
        </Grid>
      </Grid>
      <Grid container direction="column" flex={1}>
        <Grid sx={{ fontSize, fontWeight: 'bold' }}>
          {padWithZero(hours)}
        </Grid>
        <Grid sx={{
          fontSize: labelsFontSize,
          lineHeight: 1,
          fontWeight: 'normal',
        }}
        >
          {t('hours', 'Hours')}
        </Grid>
      </Grid>
      <Grid container direction="column" flex={1}>
        <Grid sx={{ fontSize, fontWeight: 'bold' }}>
          {padWithZero(minutes)}
        </Grid>
        <Grid sx={{
          fontSize: labelsFontSize,
          lineHeight: 1,
          fontWeight: 'normal',
        }}
        >
          {t('minutes', 'Minutes')}
        </Grid>
      </Grid>
      <Grid container direction="column" flex={1}>
        <Grid sx={{ fontSize, fontWeight: 'bold' }}>
          {padWithZero(seconds)}
        </Grid>
        <Grid sx={{
          fontSize: labelsFontSize,
          lineHeight: 1,
          fontWeight: 'normal',
        }}
        >
          {t('seconds', 'Seconds')}
        </Grid>
      </Grid>
    </Grid>
  );
}));

export default CountDown;
